import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from 'services/baseQuery';

export const companyUserApi = createApi({
  baseQuery: customBaseQuery,
  reducerPath: 'companyUsersApi',
  tagTypes: ['CompanyUsers'],
  endpoints: (builder) => ({
    getCompanyUsers: builder.query({
      query: (params) => ({
        url: '/company_users',
        method: 'GET',
        params,
      }),
    }),
    getDetailCompanyUser: builder.query({
      query: (id) => ({
        url: '/company_users/' + id,
        method: 'GET'
      })
    }),
    deleteCompanyUser: builder.mutation({
      query: ({ body, id }) => ({
        url: `/company_users/${id}`,
        method: 'DELETE',
        body,
      })
    }),
    createUpdateCompanyUser: builder.mutation({
      query: ({ body, id }) => ({
        url: '/company_users' + (id ? `/${id}` : ''),
        method: id ? 'PATCH' : 'POST',
        body: {
          company_user: body
        }
      })
    }),
  }),

});

export const {
  usePrefetch,
  useGetCompanyUsersQuery,
  useGetDetailCompanyUserQuery,
  useDeleteCompanyUserMutation,
  useCreateUpdateCompanyUserMutation,
} = companyUserApi;
